document.addEventListener('DOMContentLoaded', function () {
  function initSearchToggle(container) {
    const searchMenuItem = container.querySelector('.navbar-menu-item-search');
    if (!searchMenuItem) return;

    const searchToggle = searchMenuItem.querySelector('a');
    if (!searchToggle) return;

    // Toggle on click
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      searchMenuItem.classList.toggle('show-search');
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      const isClickInside = searchMenuItem.contains(e.target);
      if (!isClickInside) {
        searchMenuItem.classList.remove('show-search');
      }
    });
  }

  // Original header
  initSearchToggle(document);

  // Watch for and bind after clone is created
  const observer = new MutationObserver(() => {
    const clone = document.querySelector('.middle-sections-clone');
    if (clone && !clone.dataset.bound) {
      initSearchToggle(clone);
      clone.dataset.bound = "true"; // prevent re-binding
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
